// ─── Design Tokens ──────────────────────────────────────────────────────────
// All structural token values used across the design system.
// Imported by primaryTheme.tsx and spread into createTheme().

export const borderRadius = {
  sm: 4,
  md: 8,
  lg: 12,
  xl: 24,
  full: 9999,
} as const;

export const customShadows = {
  card: '0 2px 8px 0 rgba(16,30,54,0.04)',
  cardContent: '0px 2px 8px rgba(133,146,173,0.2)',
  modal: '0px 10px 30px rgba(0,0,0,0.15)',
  drawer: '0px 10px 30px rgba(0,0,0,0.05)',
  dropdown: '0px 4px 6px -2px rgba(0,0,0,0.05), 0px 10px 15px -3px rgba(0,0,0,0.10)',
  header: '1px 0px 10px 0px rgba(0,0,0,0.05)',
  subtle: '0 1px 3px rgba(0,0,0,0.08)',
  menu: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  menuArrow: '-2px -2px 4px rgba(0, 0, 0, 0.05)',
  none: 'none',
} as const;

export const zIndexTokens = {
  header: 1100,
  agGrid: 1250,
  dropdown: 1300,
  agGridOverlay: 1400,
  agGridPopup: 9999,
  agGridPopupModal: 19999,
  agGridTooltip: 99999,
} as const;

export const customTransitions = {
  fast: '150ms ease-in-out',
  default: '300ms ease',
  slow: '400ms ease-in-out',
  drawer: '1500ms ease-in-out',
} as const;

export const componentSizes = {
  button: {
    sm: { height: 30, minWidth: 96, borderRadius: 9999, padding: '0 16px', fontSize: '0.75rem' },
    md: { height: 36, minWidth: 131, borderRadius: 9999, padding: '0 25px', fontSize: '0.875rem' },
    lg: { height: 44, minWidth: 160, borderRadius: 9999, padding: '0 32px', fontSize: '1rem' },
  },
  inputField: {
    sm: { height: 36, minWidth: 0, borderRadius: 8, padding: '0 10px', fontSize: '13px' },
    md: { height: 48, minWidth: 0, borderRadius: 8, padding: '0 12px', fontSize: '14px' },
    lg: { height: 56, minWidth: 0, borderRadius: 8, padding: '0 14px', fontSize: '16px' },
  },
  dropdown: {
    sm: { height: 36, minWidth: 0, borderRadius: 8, padding: '0 10px', fontSize: '13px' },
    md: { height: 48, minWidth: 0, borderRadius: 8, padding: '0 12px', fontSize: '14px' },
    lg: { height: 56, minWidth: 0, borderRadius: 8, padding: '0 14px', fontSize: '16px' },
  },
} as const;

export const modalWidths = {
  xs: 420,
  sm: 600,
  md: 755,
  lg: 'calc(100% - 20%)',
  vertical: 600,
} as const;

export const drawerWidths = {
  xs: 420,
  md: 673,
  lg: 920,
} as const;
